// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Fb: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path fill="currentColor" d="M20.77,0H3.23C1.45,0,0,1.45,0,3.23v17.53C0,22.55,1.45,24,3.23,24h8.09l0.11-8.28H8.47v-3.38h2.97V9.76
	c0-2.93,1.75-4.55,4.42-4.55c1.28,0,2.62,0.23,2.62,0.23v2.88h-1.47c-1.45,0-1.9,0.9-1.9,1.83v2.19h3.24l-0.52,3.38h-2.72L14.98,24
	h5.79c1.79,0,3.23-1.45,3.23-3.23V3.23C24,1.45,22.55,0,20.77,0z"/>
</svg>;
};

export default React.memo(Fb);
